/**
 * Created by 高春超 on 2018/1/23.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import goodsCart from './modules/goodsCart';
import getters from './getter';

Vue.use(Vuex);
Vue.filter("limitToNum", function(input,num) {   //字数限制
  if(input && input.length>num){
    input = input.substring(0,num)+"...";
  }
  return input;
});
const store = new Vuex.Store({
  modules: {
    user,
    goodsCart
  },
  getters
});
store.dispatch('initSID');
store.dispatch('initName');
store.dispatch('initFace');
store.dispatch('initLevel');
store.dispatch('initSigned');
store.dispatch('initMemId');
store.dispatch('initMaket');
store.dispatch('initStoreId');
store.dispatch('initLucky');
//store.dispatch('getCartList'); // 获取购物车商品
store.dispatch('initIsFirstBuy');
export default store



// WEBPACK FOOTER //
// ./src/components/store/index.js